import { handleMarkerModal,
         HandleMarkerCats,
         HandleIndicator,
         HandleURL,
         HandleSharingLink,
         HandleActiveFloor,
         handleStackedImages } from './scripts/scripts';

const interactiveDemoApp = (function main() {
  // Page load actions.
  const init = () => {
    HandleActiveFloor()
    handleMarkerModal()
    HandleMarkerCats()
    HandleIndicator()
    HandleURL()
    HandleSharingLink()
    handleStackedImages()
  }

  // Scroll actions.
  const scroll = () => {

  }

  // Resize screen actions.
  const resize = () => {
    handleStackedImages()
    handleMarkerModal()
  }

  // Exports to DOM binds.
  return { init, scroll, resize }
}())

/**
 * DOM listener binds
 * --> Init
 * --> Scroll
 * --> Resize
 */
document.addEventListener('DOMContentLoaded', () => {
  interactiveDemoApp.init()
})

window.addEventListener('scroll', () => {
  interactiveDemoApp.scroll();
})

window.addEventListener('resize', () => {
  interactiveDemoApp.resize();
})
